import { render, staticRenderFns } from "./GoldVirtually.vue?vue&type=template&id=66e6e50e&scoped=true&"
import script from "./GoldVirtually.vue?vue&type=script&lang=ts&"
export * from "./GoldVirtually.vue?vue&type=script&lang=ts&"
import style0 from "./GoldVirtually.vue?vue&type=style&index=0&id=66e6e50e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6e50e",
  null
  
)

export default component.exports